(function () {
  function markLoaded(img) {
    var wrapper = img.closest('[data-skeleton]');
    if (wrapper) wrapper.setAttribute('data-loaded', 'true');
  }

  document.addEventListener('load', function (event) {
    if (event.target.tagName === 'IMG') markLoaded(event.target);
  }, true);

  document.addEventListener('error', function (event) {
    if (event.target.tagName === 'IMG') markLoaded(event.target);
  }, true);

  document.querySelectorAll('[data-skeleton] img').forEach(function (img) {
    if (img.complete) markLoaded(img);
  });
})();
